import { highlighterRegex, isSpecialCharacter } from './validation';

export const subjectHighlighter = (
  highlight,
  content,
  color = '#fc9f14',
  type = ''
) => {
  const params = new URLSearchParams(window?.location?.search);
  const isResource = params.get('resource_id');
  if (isResource) {
    return content;
  }
  // اگر هیلایت خالی باشد یا به هر نحوی وارد نشده باشد نیاز نیست که کار انجام بشه
  if (
    highlight === null ||
    highlight === NaN ||
    highlight === '' ||
    highlight === undefined ||
    !highlight
  )
    return content;
  /*
   * حذف علائم سیمبولیک و نگه داری هر کلمه در یک خانه از آرایه
   * مثلا آموزش و پرورش اگر با بعلاوه یا سایر علائم جدا نشده باشند یک کلمه محسوب میشود
   *
   * اول پرانتز هارو برمیداریم. بعد بجای * یا + یا ! و غیره از کاما استفاده میشه
   * بعد اگر چند فاصله پشت هم باشن اونا رو به یک فاصله تبدیل میکنیم
   **/
  const words = highlight
    ?.replace(/[()]/gi, '')
    ?.replace(/[+*!]/gi, ',')
    ?.replace(/\s\s+/gi, ' ');
  let highlightArray = words?.split(',');

  // حذف نال ها از آرایه زیرا در بعضی شرایط یکی از مقادر زیر اتفاق میفتاد و جهت رفع باگ این اضافه شد
  highlightArray = highlightArray?.filter(
    (n) => n !== null && n !== '' && n !== ' ' && n !== undefined
  );
  // آرایه را بر اساس بزرگترین کلمه ها مرتب میکنیم تا اگر مثلا کلمه ایرانسل و ایرانسلم وجود داشت ایرانسلم انتخاب شود
  // highlightArray = highlightArray?.sort(function (a, b) {
  // ASC  -> a.length - b.length
  // DESC -> b.length - a.length
  //   return b.length - a.length;
  // });

  // نرمال سازی آرایه
  highlightArray?.forEach((selectedWord, idx) => {
    let regexWord = selectedWord?.trim()?.replace(/[یيئيﻱﺉ]/gi, '[یيئيﻱﺉ]');
    regexWord = regexWord?.replace(/[كک]/gi, '[كک]');
    regexWord = regexWord?.replace(/[اآ]/gi, '[اآ]');
    regexWord = regexWord?.replace(/[ةه]/gi, '[ةه]');
    regexWord = regexWord?.replace(/[@]/gi, '[@]?');
    regexWord = regexWord?.replace(/[#]/gi, '[#]?');

    /*  برای این اضافه شد که اگر بعد یا قبل از کلمه یکی از این موارد رو داشت بازم اوکی باشه
     ** \\u200C is for: ZERO WIDTH NON-JOINER نیم فاصله
     ** اگر لازم شد از این موارد هم میشه استفاده کرد که برای سایر حالت های فاصله هست
     ** \\u200B|\\u180E|\\u2060|\\uFEFF
     */
    highlightArray[idx] = `[\\u200C]?${regexWord}[\\u200C]?`;
  });

  const highlighterFormat = (matchedWordWithSpecialChar) => {
    let firstSpecialChar = '';
    let lastSpecialChar = '';
    let exactMatchedWord = matchedWordWithSpecialChar;
    if (isSpecialCharacter(exactMatchedWord[0])) {
      firstSpecialChar = exactMatchedWord.slice(0, 1);
      exactMatchedWord = exactMatchedWord.slice(1);
    }
    if (isSpecialCharacter(exactMatchedWord[exactMatchedWord.length - 1])) {
      lastSpecialChar = exactMatchedWord.slice(exactMatchedWord.length - 1);
      exactMatchedWord = exactMatchedWord.slice(0, exactMatchedWord.length - 1);
    }
    return `${firstSpecialChar}<span style="${
      type === 'color'
        ? `color:${color}; font-weight: 700`
        : `background-color:${color}`
    }">${exactMatchedWord}</span>${lastSpecialChar}`;
  };

  let newContent = content;
  if (highlightArray?.length > 0) {
    newContent = newContent?.replace(
      highlighterRegex(highlightArray?.join('|')),
      highlighterFormat
    );
  }

  return newContent;
};
